export function getLocalStorage(): Storage | undefined {
    try {
        const storage = window.localStorage;
        // A corrupted Firefox profile hands out a storage that throws on use (NS_ERROR_FAILURE)
        storage.getItem('');

        return storage;
    } catch (_e) {
        // returns undefined
    }
}

export function getSessionStorage(): Storage | undefined {
    try {
        return window.sessionStorage;
    } catch (_e) {
        // returns undefined
    }
}
